function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'black': 'rgb(0, 0, 0)','white': 'rgb(255, 255, 255)','grey': 'rgb(125, 125, 125)','light-grey': 'rgb(211, 211, 211)','dark-grey': 'rgb(47, 79, 79)','charcoal': 'rgb(54, 69, 79)','graphite': 'rgb(56, 56, 56)','beige': 'rgb(245, 245, 220)','ivory': 'rgb(255, 255, 240)','taupe': 'rgb(72, 60, 50)','coffee': 'rgb(111, 78, 55)','blues': '','navy-blue': 'rgb(30, 58, 138)','royal-blue': 'rgb(65, 105, 225)','cobalt-blue': 'rgb(0, 71, 171)','sky-blue': 'rgb(135, 206, 235)','baby-blue': 'rgb(137, 207, 240)','wave': 'rgb(0, 95, 153)','turquoise': 'rgb(64, 224, 208)','teal': 'rgb(0, 128, 128)','aqua': 'rgb(0, 255, 255)','steel-blue': 'rgb(70, 130, 180)','midnight-blue': 'rgb(25, 25, 112)','deep-blue': 'rgb(0, 0, 139)','reds-pinks': '','red': 'rgb(225, 29, 72)','burgundy': 'rgb(128, 0, 32)','crimson': 'rgb(220, 20, 60)','scarlet': 'rgb(255, 36, 0)','maroon': 'rgb(128, 0, 0)','pink': 'rgb(255, 105, 180)','dust-pink': 'rgb(232, 193, 197)','hot-pink': 'rgb(255, 20, 147)','rose': 'rgb(255, 0, 127)','salmon': 'rgb(250, 128, 114)','greens': '','olive-green': 'rgb(85, 107, 47)','neon-green': 'rgb(57, 255, 20)','lime-green': 'rgb(50, 205, 50)','forest-green': 'rgb(34, 139, 34)','emerald-green': 'rgb(80, 200, 120)','mint-green': 'rgb(152, 255, 152)','jade': 'rgb(0, 168, 107)','sea-green': 'rgb(46, 139, 87)','dark-green': 'rgb(0, 100, 0)','yellows-oranges': '','yellow': 'rgb(255, 215, 0)','neon-yellow': 'rgb(204, 255, 0)','mustard-yellow': 'rgb(255, 219, 88)','gold': 'rgb(255, 215, 0)','orange': 'rgb(255, 140, 0)','orange-x': 'rgb(255, 69, 0)','blaze': 'rgb(255, 69, 0)','peach': 'rgb(255, 229, 180)','amber': 'rgb(255, 191, 0)','purples-violets': '','purple': 'rgb(128, 0, 128)','lavender': 'rgb(230, 230, 250)','violet': 'rgb(138, 43, 226)','lilac': 'rgb(200, 162, 200)','mauve': 'rgb(224, 176, 255)','plum': 'rgb(221, 160, 221)','browns-earth-tones': '','chocolate': 'rgb(210, 105, 30)','copper': 'rgb(184, 115, 51)','bronze': 'rgb(205, 127, 50)','rust': 'rgb(183, 65, 14)','sienna': 'rgb(160, 82, 45)','tan': 'rgb(210, 180, 140)','metallics-special-tones': '','silver': 'rgb(192, 192, 192)','gold': 'rgb(255, 215, 0)','rose-gold': 'rgb(183, 110, 121)','black': 'rgb(0, 0, 0)','white': 'rgb(255, 255, 255)','grey': 'rgb(125, 125, 125)','navy-blue': 'rgb(30, 58, 138)','royal-blue': 'rgb(65, 105, 225)','red': 'rgb(225, 29, 72)','burgundy': 'rgb(128, 0, 32)','olive-green': 'rgb(85, 107, 47)','neon-green': 'rgb(57, 255, 20)','orange': 'rgb(255, 140, 0)','yellow': 'rgb(255, 215, 0)','purple': 'rgb(128, 0, 128)','pink': 'rgb(255, 105, 180)','black': 'rgb(0, 0, 0)','white': 'rgb(255, 255, 255)','grey': 'rgb(125, 125, 125)','navy-blue': 'rgb(30, 58, 138)','royal-blue': 'rgb(65, 105, 225)','cobalt-blue': 'rgb(0, 71, 171)','cobalt': 'rgb(0, 71, 171)','red': 'rgb(225, 29, 72)','burgundy': 'rgb(128, 0, 32)','olive-green': 'rgb(85, 107, 47)','neon-green': 'rgb(57, 255, 20)','orange': 'rgb(255, 140, 0)','orange-x': 'rgb(255, 69, 0)','yellow': 'rgb(255, 215, 0)','neon-yellow': 'rgb(204, 255, 0)','purple': 'rgb(128, 0, 128)','dusty-pink': 'rgb(232, 193, 197)',};

    this.images = {};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
